import BaseEntity from "./base.entity";
import uuid from "uuid";

export default class CashRegister extends BaseEntity {
  defaultParams() {
    return {
      uuid: uuid()
    };
  }

  additions() {
    return this.cash_transactions
      .filter(cash_transaction => cash_transaction.type === "addition")
      .reduce((acc, cur) => acc + cur.value, 0);
  }

  withdrawals() {
    return this.cash_transactions
      .filter(cash_transaction => cash_transaction.type === "withdrawal")
      .reduce((acc, cur) => acc + cur.value, 0);
  }

  cancelledSales() {
    return this.sales_refs
      .filter(sale => sale.status === "cancelled")
      .reduce((acc, cur) => acc + cur.revenues(), 0);
  }

  totalSales() {
    return this.sales_refs
      .filter(sale => sale.status === "active")
      .reduce((acc, cur) => acc + cur.revenues(), 0);
  }

  moneySales() {
    return this.totalMoney() + this.withdrawals() - this.additions()
  }

  totalMoney() {
    return this.total_value || 0;
  }
}



// WEBPACK FOOTER //
// ./src/core/entity/cash_register.entity.js